module.exports = __webpack_public_path__ + "img/Lean-Experimentation-600x400.479c15bc.png";